module.exports = __webpack_public_path__ + "img/code.9a9addd3.jpg";